import React from 'react';
import R from 'ramda';
import { TextField, Checkbox } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import ContractingYear from '../../../contracting/buyer-wizard/contract-settings/contracting-year';
import pluralize from 'pluralize';
import Select from 'react-select';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const ContractInfoForm = ({
  updateProps,
  startDateValue,
  endDateValue,
  newPartner,
  partners,
  selectedPartner,
  allEmailsFromBody,
  showNewPartnerForm,
}) => {
  const dateError = (() => {
    if (!startDateValue) return 'Start Date is required';
    if (!endDateValue) return 'End Date is required';
    if (startDateValue >= endDateValue) return 'End Date must be after the start date.';
  })();
  const partnerError = (() => {
    if (selectedPartner && selectedPartner.partnerId
      && !(selectedPartner.contactIds && selectedPartner.contactIds.length)) {
      return 'Please select at least one contact';
    }
  })();
  const onSelectPartner = ({ partner }) => {
    updateProps('action_dialog', {
      selectedPartner: {
        partnerName: partner.name,
        partnerAvatar: partner.avatar,
        partnerId: partner.id,
        contacts: partner.contacts,
        emails: partner.contacts.map(obj => obj.email),
        contactIds: partner.contacts.map(obj => obj.id),
      },
    });
  };
  const onCheckContact = contact => (_, checked) => {
    updateProps('action_dialog', {
      selectedPartner: {
        ...selectedPartner,
        emails: checked
          ? [...selectedPartner.emails, contact.email]
          : selectedPartner.emails.filter(email => email !== contact.email),
        contactIds: checked
          ? [...selectedPartner.contactIds, contact.id]
          : selectedPartner.contactIds.filter(id => id !== contact.id),
      },
    });
  };
  const onCheckShowNewPartnerForm = (_, checked) => updateProps('action_dialog', {
    showNewPartnerForm: checked,
    selectedPartner: checked ? {} : selectedPartner,
  });
  return (
    <div>
      <ContractingYear
        startDate={startDateValue}
        endDate={endDateValue}
        onChange={({ key, value }) => updateProps('action_dialog', { [`${key}Value`]: value })}
      />
      <div style={{ fontSize: '12px', color: 'red', clear: 'both' }}>{dateError}</div>
      <div style={{ clear: 'both' }}>
        <label><b>Please search for a partner:</b></label>
        <br /><br />
        <Select
          wrapperStyle={{ width: '100%' }}
          name="select-partner"
          onChange={onSelectPartner}
          options={partners.map(partner => ({
            value: partner.id,
            label: `${partner.name} ${partner.contacts.length} (${pluralize('contacts', partner.contacts.length)})`,
            partner,
          }))}
          value={selectedPartner.partnerId}
          placeholder="Search & Pick A Partner"
          clearable={false}
          scrollMenuIntoView={false}
        />
        <div style={{ fontSize: '12px', color: 'red', clear: 'both' }}>{partnerError}</div>
        <br />
        {
          Boolean(selectedPartner && selectedPartner.contacts && selectedPartner.contacts.length)
          && (
            <div style={{ marginBottom: '16px' }}>
              {
                selectedPartner.contacts.map(contact => (
                  <Checkbox
                    key={contact.id}
                    label={contact.email}
                    checked={selectedPartner.contactIds.indexOf(contact.id) > -1}
                    onCheck={onCheckContact(contact)}
                  />
                ))
              }
            </div>
          )
        }
        <Checkbox
          label={<label><b>Or enter new partner info (we will create new partner/contact):</b></label>}
          checked={showNewPartnerForm}
          onCheck={onCheckShowNewPartnerForm}
        />
        <div style={{ visibility: showNewPartnerForm ? 'visible' : 'hidden', marginTop: '12px' }}>
          <div>Company Name (Required):</div>
          <TextField
            id="companyName"
            style={{ width: '100%' }}
            hintStyle={{ fontSize: '12px' }}
            inputStyle={{ fontSize: '14px' }}
            hintText="Enter company name here..."
            underlineStyle={{ borderColor: '#00bcd4' }}
            value={newPartner.companyName}
            onChange={(_, val) => updateProps('action_dialog', { newPartner: R.merge(newPartner, { companyName: val }) })}
          />
          <div>Email (Required):</div>
          <TextField
            id="email"
            style={{ width: '100%' }}
            hintStyle={{ fontSize: '12px' }}
            inputStyle={{ fontSize: '14px' }}
            underlineStyle={{ borderColor: '#00bcd4' }}
            value={newPartner.email}
            onChange={(_, val) => updateProps('action_dialog', {
              newPartner: R.merge(newPartner, { email: val }), // if email is modified, remove original supplierId
            })}
          />
          {
            !isNilOrEmpty(allEmailsFromBody) && (
              <div style={{ border: '1px dashed #e0e0e0', marginTop: '8px', padding: '8px', width: '100%' }}>
                <small>We have picked up below email addresses from the message:</small>
                {
                  allEmailsFromBody.map(email => (
                    <div key={email} className="flex-tc-sb" style={{ marginBottom: '4px' }}>
                      <div style={{ width: '80%', wordWrap: 'break-word' }}>
                        {email}
                      </div>
                      <FlatButton
                        onTouchTap={() => updateProps('action_dialog', {
                          newPartner: R.merge(newPartner, { email }), // if email is modified, remove original supplierId
                        })}
                        style={{ border: '1px solid #00bcd4', height: '24px', lineHeight: '24px', verticalAlign: 'top' }}
                        label="Use this address"
                        labelStyle={{ textTransform: 'none', color: '#00bcd4', padding: '0 4px', verticalAlign: '', top: '-1px' }}
                      />
                    </div>
                  ))
                }
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ContractInfoForm;



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/dialog/contractInfoForm.jsx